import { render, staticRenderFns } from "./MobileCallTicketModal.vue?vue&type=template&id=3981006e&scoped=true&"
import script from "./MobileCallTicketModal.vue?vue&type=script&lang=js&"
export * from "./MobileCallTicketModal.vue?vue&type=script&lang=js&"
import style0 from "./MobileCallTicketModal.vue?vue&type=style&index=0&id=3981006e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981006e",
  null
  
)

export default component.exports